export const USERLOGIN_SHOW = 'UserLogin/Show';
export const USERLOGIN_LOGIN = 'UserLogin/Show';
export const USERLOGIN_REGISTRATION = 'UserLogin/Registration';

export default {
  USERLOGIN_SHOW,
  USERLOGIN_LOGIN,
  USERLOGIN_REGISTRATION
}